/*
 * <set-builder> — routine set builder: checkbox list, tier meter + message, "add N items" via RM.addToCart.
 * data-msg-0..3 : tier messages (0 = fewer than 2 items), data-label-one / data-label-other (with __N__).
 */
if (!customElements.get('set-builder')) {
  class SetBuilder extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-set-item]')];
      this.fill = this.querySelector('[data-set-fill]');
      this.message = this.querySelector('[data-set-message]');
      this.button = this.querySelector('[data-set-add]');
      this.tiers = [...this.querySelectorAll('[data-set-tier]')];
      this.onChange = () => this.update();
      this.onAdd = () => this.add();
      this.addEventListener('change', this.onChange);
      this.button?.addEventListener('click', this.onAdd);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.button?.removeEventListener('click', this.onAdd);
    }

    get selected() {
      return this.items.filter((input) => input.checked);
    }

    update() {
      const count = this.selected.length;
      const widths = [8, 8, 34, 67, 100];
      const tier = Math.min(count, 4);
      if (this.fill) this.fill.style.width = `${widths[tier]}%`;
      if (this.message) this.message.textContent = this.dataset[`msg${count <= 1 ? 0 : tier - 1}`] || '';
      this.tiers.forEach((el) => {
        el.toggleAttribute('data-reached', count >= Number(el.dataset.setTier));
      });
      if (this.button) {
        const label = count === 1 ? this.dataset.labelOne : (this.dataset.labelOther || '').replace('__N__', String(count));
        this.button.textContent = count === 0 ? this.dataset.labelNone : label;
        this.button.toggleAttribute('disabled', count === 0);
      }
    }

    async add() {
      const items = this.selected
        .map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }))
        .filter((item) => item.id);
      if (items.length === 0) {
        if (this.message) this.message.textContent = this.dataset.error || '';
        return;
      }
      this.button.setAttribute('aria-busy', 'true');
      try {
        await window.RM.addToCart(items, { source: 'set-builder' });
      } catch (error) {
        if (this.message) this.message.textContent = this.dataset.error || error.message;
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('set-builder', SetBuilder);
}
